module.exports = __webpack_public_path__ + "static/media/Olympics_App_recording.6a53d15c.mp4";